import * as types from '../../actions/types';

const initialState = {
  loading: false,
  error: null,
  taskMonitorData: [],
  statistics: null,
  failedTasks: [],
  lastUpdated: null,
};

const taskMonitorReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TASK_MONITOR_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.TASK_MONITOR_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.FETCH_TASK_MONITOR_SUCCESS:
      let taskData = [];
      
      // Handle different response formats
      if (Array.isArray(action.payload)) {
        taskData = action.payload;
      } else if (action.payload && Array.isArray(action.payload.results)) {
        taskData = action.payload.results;
      } else if (action.payload && Array.isArray(action.payload.data)) {
        taskData = action.payload.data;
      } else if (action.payload && typeof action.payload === 'object') {
        taskData = action.payload.results || action.payload.data || action.payload.items || [];
      }
      
      return {
        ...state,
        loading: false,
        taskMonitorData: taskData,
        error: null,
        lastUpdated: new Date().toISOString(),
      };

    case types.FETCH_TASK_STATISTICS_SUCCESS:
      return {
        ...state,
        statistics: action.payload,
      };

    case types.FETCH_FAILED_TASKS_SUCCESS:
      return {
        ...state,
        failedTasks: Array.isArray(action.payload) ? action.payload : [],
      };

    case types.CLEANUP_TASKS_SUCCESS:
      return {
        ...state,
        // Optionally refresh the data after cleanup
      };

    // Add a reset action
    case 'RESET_TASK_MONITOR':
      return initialState;

    default:
      return state;
  }
};

export default taskMonitorReducer;
